export default __webpack_public_path__ + "static/media/circleUser.d2c08e1d.svg";